/**
 * Formats text by converting markdown-style bold (**text**) to HTML <strong> tags
 * and newline characters to <br> tags.
 * @param {string} text - The text to format.
 * @returns {string} - The formatted text.
 */
export function formatText(text) {
  // Replace **text** with <strong>text</strong>
  const boldFormatted = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  // Replace newline characters with <br>
  return boldFormatted.replace(/\n/g, '<br>');
}
